export default __webpack_public_path__ + "static/media/About.2ce08e0c.jpg";